import { Spin } from "antd";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { LayoutMain } from "../Layout/LayoutMain";
import { LayoutLogin } from "../Layout/LayoutLogin";
import LoginV4Component from "../Component/Auth/LoginV4Component";

const LoginV2Component = lazy(() =>
  import("../Component/Auth/LoginV2Component")
);
const HomeComponentV2 = lazy(() => import("../Component/Main/HomeComponentV2"));
const RouteVehicleComponent = lazy(() =>
  import("../Component/Categorys/RouteVehicleComponent")
);
const RegisterComponent = lazy(() =>
  import("../Component/Auth/RegisterComponent")
);
const ForgotPasswordComponent = lazy(() =>
  import("../Component/Auth/ForgotPasswordComponent")
);
const ResetPasswordComponent = lazy(() =>
  import("../Component/Auth/ResetPasswordComponent")
);
const ProfiveComponent = lazy(() =>
  import("../Component/Auth/ProfiveComponent")
);
const ChangePasswordComponent = lazy(() =>
  import("../Component/Auth/ChangePasswordComponent")
);
const VerificationComponent = lazy(() =>
  import("../Component/Auth/VerificationComponent")
);
const PostOfficeComponent = lazy(() =>
  import("../Component/Categorys/PostOfficeComponent")
);
const AddressVerification = lazy(() =>
  import("../Component/System/AddressVerification")
);

// Reports
const GetLadingTemporary = lazy(() =>
  import("../Component/Reports/GetLadingTemporary")
);
const OverViewReportComponent = lazy(() =>
  import("../Component/Reports/OverViewReportComponent")
);
const CustomerPaymentDealineComponent = lazy(() =>
  import("../Component/Reports/CustomerPaymentDealineComponent")
);
const KpiDeliveryCODReportComponent = lazy(() =>
  import("../Component/Reports/KpiDeliveryCODReportComponent")
);
const OutstandingDebtReportComponent = lazy(() =>
  import("../Component/Reports/OutstandingDebtReportComponent")
);
const PaymentReportComponent = lazy(() =>
  import("../Component/Reports/PaymentReportComponent")
);
const PaymentCODCustomerComponent = lazy(() =>
  import("../Component/Reports/PaymentCODCustomerComponent")
);

// Main components
const LadingCreateV4 = lazy(() => import("../Component/Main/LadingCreateV4"));
const LadingExcelV4 = lazy(() => import("../Component/Main/LadingExcelV4"));
const LadingCreateV3 = lazy(() => import("../Component/Main/LadingCreateV3"));
const LadingExcelV3 = lazy(() => import("../Component/Main/LadingExcelV3"));

const SearchLadingV2 = lazy(() => import("../Component/Main/SearchLadingV2"));
const LookupLading = lazy(() => import("../Component/Main/LookupLading"));

const SetupMain = lazy(() => import("../Component/Setup/SetupMain"));
const LadingOutPrint = lazy(() =>
  import("../Component/Categorys/LadingOutPrint")
);
const LadingPrintFromExcelAveryComponent = lazy(() =>
  import("../Component/Categorys/LadingPrintFromExcelAveryComponent")
);

const TimelineTransport = lazy(() =>
  import("../Component/Categorys/TimelineTransport")
);
const CustomerComplain = lazy(() =>
  import("../Component/Complain/CustomerComplain")
);
const CustomerComplainList = lazy(() =>
  import("../Component/Complain/CustomerComplainList")
);
const LadingGetPriceComponent = lazy(() =>
  import("../Component/Categorys/LadingGetPriceComponent")
);

//Warehouse reports
const WareHouseImportReportComponent = lazy(() =>
  import("../Component/Reports/WareHouseImportReportComponent")
);
const WareHouseOutputReportComponent = lazy(() =>
  import("../Component/Reports/WareHouseOutputReportComponent")
);
const WareHouseTranportReportComponent = lazy(() =>
  import("../Component/Reports/WareHouseTranportReportComponent")
);
const WareHouseInventoryReportComponent = lazy(() =>
  import("../Component/Reports/WareHouseInventoryReportComponent")
);
const WareHouseSupplierReportComponent = lazy(() =>
  import("../Component/Reports/WareHouseSupplierReportComponent")
);
const WareHousePersoninChargeReportComponent = lazy(() =>
  import("../Component/Reports/WareHousePersoninChargeReportComponent")
);

export const Routers = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <Spin size="large" />
        </div>
      }
    >
      <Routes>
        <Route element={<LayoutMain />}>
          <Route path="/home" element={<HomeComponentV2 />} />
          <Route
            path="/lo-trinh-giao-hang"
            element={<RouteVehicleComponent />}
          />
          <Route path="/thong-tin-ca-nhan" element={<ProfiveComponent />} />

          <Route
            path="/xac-thuc-tai-khoan"
            element={<VerificationComponent />}
          />
          <Route path="/mang-luoi-buu-cuc" element={<PostOfficeComponent />} />

          {/* CATEGORY */}
          <Route
            path="/thoi-gian-toan-trinh-phat-hang-dich-vu"
            element={<TimelineTransport />}
          />
          <Route path="/ho-tro-don-hang" element={<CustomerComplain />} />
          <Route
            path="/danh-sach-ho-tro-don-hang"
            element={<CustomerComplainList />}
          />
          <Route
            path="/uoc-tinh-cuoc-phi"
            element={<LadingGetPriceComponent />}
          />

          {/* #region BÁO CÁO */}
          <Route
            path="/bao-cao-nhap-kho"
            element={<WareHouseImportReportComponent />}
          />
          <Route
            path="/bao-cao-xuat-kho"
            element={<WareHouseOutputReportComponent />}
          />
          <Route
            path="/bao-cao-chuyen-kho"
            element={<WareHouseTranportReportComponent />}
          />
          <Route
            path="/bao-cao-ton-kho"
            element={<WareHouseInventoryReportComponent />}
          />
          <Route
            path="/bao-cao-ton-kho-ncc"
            element={<WareHouseSupplierReportComponent />}
          />
          <Route
            path="/bao-cao-ton-kho-npt"
            element={<WareHousePersoninChargeReportComponent />}
          />

          <Route path="/cong-no-tam-tinh" element={<GetLadingTemporary />} />
          <Route
            path="/bao-cao-tong-quan"
            element={<OverViewReportComponent />}
          />
          <Route
            path="/bao-cao-dealine-thanh-toan"
            element={<CustomerPaymentDealineComponent />}
          />
          <Route
            path="/bao-cao-kpi-giao-hang-cod"
            element={<KpiDeliveryCODReportComponent />}
          />
          <Route
            path="/bao-cao-ton-no"
            element={<OutstandingDebtReportComponent />}
          />
          <Route
            path="/bang-ke-thanh-toan"
            element={<PaymentReportComponent />}
          />
          <Route
            path="/bang-ke-thanh-toan-cod"
            element={<PaymentCODCustomerComponent />}
          />

          {/* VẬN ĐƠN */}
          <Route path="/tao-nhanh-van-don-v4" element={<LadingCreateV3 />} />
          <Route path="/tao-don-hang" element={<LadingCreateV4 />} />
          <Route path="/upload-excel-van-don-v4" element={<LadingExcelV3 />} />
          <Route path="/tao-don-hang-excel" element={<LadingExcelV4 />} />
          <Route path="/tim-kiem-van-don" element={<SearchLadingV2 />} />
          <Route path="/tra-cuu-van-don" element={<LookupLading />} />
          <Route path="/cai-dat-tai-khoan" element={<SetupMain />} />
          <Route path="/tra-cuu-dia-chi" element={<AddressVerification />} />

          <Route
            path="/in-bill-tu-excel"
            element={<LadingPrintFromExcelAveryComponent />}
          />

          <Route path="/doi-mat-khau" element={<ChangePasswordComponent />} />
        </Route>

        {/* TÀI KHOẢN */}
        <Route element={<LayoutLogin />}>
          <Route path="/reset" element={<ResetPasswordComponent />} />

          <Route path="/register" element={<RegisterComponent />} />
          <Route path="/forgot" element={<ForgotPasswordComponent />} />
          <Route path="/print-bill" element={<LadingOutPrint />} />
          <Route path="/" element={<LoginV2Component />} />
          {/* <Route path="/" element={<LoginV4Component />} /> */}
        </Route>
      </Routes>
    </Suspense>
  );
};
